//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useSelector } from 'react-redux';

import { getHasInstagramManageMessagesFeatureAndPermissions } from '@account-settings/redux/facebook-instagram/selectors/getFbIgFeatures';
import { useConnectedInstagramAccount } from '@instagram-account/hooks/useConnectedInstagramAccount';

export const useHasInstagramManageMessagesFeatureAndPermissions = () => {
  const { connectedInstagramAccount, isFetchingConnectedInstagramAccount } =
    useConnectedInstagramAccount();

  const hasInstagramManageMessagesFeatureAndPermissions = useSelector(
    getHasInstagramManageMessagesFeatureAndPermissions,
  );

  return {
    isFetchingInstagramManageMessagesFeatureAndPermissions:
      isFetchingConnectedInstagramAccount,
    hasInstagramManageMessagesFeatureAndPermissions:
      connectedInstagramAccount &&
      hasInstagramManageMessagesFeatureAndPermissions,
  };
};
